

const SIZE_TYPE = {
    DESKTOP: 'desktop',
    TABLET: 'tablet',
    MOBILE: 'mobile'
};

const sizeType = () => {
    const s = window.innerWidth;
    if (s >= 1200) return SIZE_TYPE.DESKTOP;
    if (s >= 768) return SIZE_TYPE.TABLET;
    return SIZE_TYPE.MOBILE;
}

// let sizeType() = sizeType();

const iOS = () => {
    return [
        'iPad Simulator',
        'iPhone Simulator',
        'iPod Simulator',
        'iPad',
        'iPhone',
        'iPod'
    ].includes(navigator.platform)
        // iPad on iOS 13 detection
        || (navigator.userAgent.includes("Mac") && "ontouchend" in document)
}

// Browsers Google Pay documents as supported, on any device:
// Chrome, Firefox, Safari, Edge, Opera, UC Browser.
// https://developers.google.com/pay/api/web/guides/setup
// Chrome on a Samsung phone is allowed. Samsung Internet is not on the list.
// Android WebView and Facebook/Instagram in-app browsers are not functional.
export function isGooglePayBrowser(userAgent) {
    const ua = String(userAgent || "");
    if (/;\s*wv\b|FBAN|FBAV|FB_IAB|Instagram/i.test(ua)) {
        return false;
    }
    if (/SamsungBrowser/i.test(ua)) {
        return false;
    }
    if (/EdgA\/|EdgiOS|Edg\/|OPR\/|Opera Mini|Opera\/|OPiOS|UCBrowser|Firefox\/|FxiOS|CriOS|Chrome\//i.test(ua)) {
        return true;
    }
    return /Safari\//.test(ua);
}

const GOOGLE = () => {
    return isGooglePayBrowser(navigator.userAgent);
};

const inAppFaceBook = () => {
    const ua = navigator.userAgent || navigator.vendor || window.opera;
    return (ua.indexOf("FBAN") > -1) || (ua.indexOf("FBAV") > -1);
}

export default {
    install: (app/*, options*/) => {
        app.config.globalProperties.$responsive = (jsonPath) => {
            if (jsonPath == null) return null;
            return jsonPath[sizeType()] ;//|| jsonPath[SIZE_TYPE.MOBILE] || jsonPath[SIZE_TYPE.TABLET] || jsonPath[SIZE_TYPE.DESKTOP];
        }

        app.config.globalProperties.$isDesktop = (allowLower) => {return (sizeType() == SIZE_TYPE.DESKTOP || (allowLower && sizeType() == SIZE_TYPE.TABLET && !inAppFaceBook()))};
        app.config.globalProperties.$isTablet = (allowLower) => {return (sizeType() == SIZE_TYPE.TABLET || (allowLower && sizeType() == SIZE_TYPE.MOBILE))};
        app.config.globalProperties.$isMobile = () => {return (sizeType() == SIZE_TYPE.MOBILE || inAppFaceBook())};
        app.config.globalProperties.$isIOS = () => {return iOS()};
        app.config.globalProperties.$isGOOGLE = () => {return GOOGLE()};
        app.config.globalProperties.$sizeType = sizeType();
    }
}